import { useCallback, useMemo, useState } from 'react';

import { EWebclientSnippet } from '../../../constants/EWebclientSnippet';
import { toastInfoTranslated } from '../../../helpers/toast';
import {
  createAdvancedWebclientSnippet,
  createSimpleWebclientSnippet,
} from '../../../helpers/webclientHelper';
import { useWebclient } from './useWebclient';

export const useWebclientSnippet = () => {
  const { webclient, selectedWebclientConfig } = useWebclient();

  const [snippetType, setSnippetType] = useState<EWebclientSnippet>(
    EWebclientSnippet.SIMPLE,
  );

  const snippetContent = useMemo(
    () =>
      snippetType === EWebclientSnippet.SIMPLE
        ? createSimpleWebclientSnippet(webclient, selectedWebclientConfig)
        : createAdvancedWebclientSnippet(webclient, selectedWebclientConfig),
    [snippetType, webclient, selectedWebclientConfig],
  );

  const copySnippetToClipboard = useCallback(() => {
    navigator.clipboard.writeText(snippetContent);
    toastInfoTranslated('Copied to clipboard');
  }, [snippetContent]);

  // This is only happening if there is no any Webclient config on the Webclient settings page, so the system needs to apply the default Conversed config/style.
  // So in that case the user won't be able to copy the config snippet, because there is no any config.
  if (!selectedWebclientConfig?.config) {
    return {
      copySnippetToClipboard: () => {},
      snippetContent: '',
      snippetType,
      setSnippetType,
    };
  }

  return {
    copySnippetToClipboard,
    snippetContent,
    snippetType,
    setSnippetType,
  };
};
